import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../../utils/scroll';
import { transformationRows, transformationFooterStats } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-221" data-mp="2ffdpkivf2uhn">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-222" data-mp="2bfbuisk6szbc">
        <SectionTag icon="⚡" data-id="element-223" data-mp="2bh6hecf0r1i2">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-224" data-mp="26nbocidixa6b">
          Tus domingos no deberían terminar así...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-225" data-mp="2z4eazx334m49">
          Un domingo por la noche, buscando ejercicios sueltos en YouTube que no sabes si van a funcionar el
          martes con tus chavales.
        </p>

        <div className="mt-6 rounded-2xl border border-naranja/30 bg-naranja/5 p-5 text-left sm:p-6" data-id="element-226" data-mp="1597t8gct6xz2">
          <p className="font-heading text-sm font-semibold uppercase tracking-wide text-naranja" data-id="element-227" data-mp="1a5y5stpenbfq">
            Recupera tus domingos
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-228" data-mp="we1pdmx3mpz6">
            <span className="font-semibold text-gris-oscuro" data-id="element-229" data-mp="10fd9jcx7eizz">El coste real:</span> Planificar manualmente te
            quita de 3 a 5 horas por semana. Es el equivalente a un mes entero de trabajo al año quemado en
            YouTube, grupos de WhatsApp de entrenadores y dudas mentales.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-230" data-mp="hilqn4lkq5wg">
        <div className="space-y-4" data-id="element-231" data-mp="hivm37pe159j">
          {transformationRows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-gris-claro bg-bg-secondary p-5 sm:p-6" data-id="element-232" data-mp="27wcjictc02ho" data-mpi={i}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-233" data-mp="3bslpqs6d8j8l">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-234" data-mp="36vd5mm1nq54p">
                <div className="flex items-start gap-3" data-id="element-235" data-mp="7f6qwu3yw1h8">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-rojo/15" data-id="element-236" data-mp="7grm8ly3vog5">
                    <XIcon size={14} className="text-rojo" data-id="element-237" data-mp="3urr8rnrj8yqj" />
                  </div>
                  <div data-id="element-238" data-mp="3upmz0p6yd5ic">
                    <p className="text-xs font-semibold uppercase tracking-wide text-rojo" data-id="element-239" data-mp="3pswffrvxvrs6">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-240" data-mp="r2e8t1wbjp02">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-241" data-mp="mb5xg0bfhtk9">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/15" data-id="element-242" data-mp="tnc60dr2513q">
                    <CheckIcon size={14} className="text-success" data-id="element-243" data-mp="yldrt6fvbeiw" />
                  </div>
                  <div data-id="element-244" data-mp="13l0ee6hl674d">
                    <p className="text-xs font-semibold uppercase tracking-wide text-success" data-id="element-245" data-mp="13kgxmt3o9orx">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-gris-oscuro" data-id="element-246" data-mp="17oev6zdcmriv">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-247" data-mp="1hjgl3xfg7xmi">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-248" data-mp="1mbzu0h36y4kz">Quiero dejar de improvisar</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-249" data-mp="1r9t0zccbj2mb">
          <ScrollHintTable minWidth="480px" data-id="element-250" data-mp="1ra1e95ccs9y1">
            <div className="grid grid-cols-3 divide-x divide-gris-claro bg-white" data-id="element-251" data-mp="1vcy2pcokr09w">
              {transformationFooterStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-252" data-mp="20c295vk46jwj">
                  <span className="font-heading text-xl font-bold text-naranja sm:text-2xl" data-id="element-253" data-mp="1mmz9wgt87u6c">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-254" data-mp="1il47ta3h1cri">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}